const HUE = 330
const SATURATION = 82
const LIGHTNESS = 58

/**
 * How strongly the ghost of the other version reads over the one on screen.
 * The canvas draws one at the same half strength, from the renderer's own
 * `CanvasComparison::GHOST_OPACITY` - this is the mark for it, not the ghost.
 */
const GHOST_OPACITY = 0.5

const hsl = (alpha: number) =>
  `hsla(${HUE}, ${SATURATION}%, ${LIGHTNESS}%, ${alpha})`

/**
 * The colour that marks "the other version" in a comparison, defined once so
 * every surface that marks it agrees.
 *
 * Not a theme token: there is no pink in the palette. The values read on both
 * the light and the dark ground.
 */
export const COMPARE_TINT = {
  /** Text and other full-strength marks. */
  strong: `hsl(${HUE}, ${SATURATION}%, ${LIGHTNESS}%)`,
  /** A wash behind a row, over either ground. */
  wash: hsl(0.14),
  /** The same wash, one step up, for a hover or a connecting rule. */
  washStrong: hsl(0.28),
  /** The mark for the other version laid over this one, at a ghost's strength. */
  ghost: hsl(GHOST_OPACITY),
} as const
